import * as React from 'react';
import Div from "@jumbo/shared/Div";
import {Typography} from "@mui/material";
import KeyboardBackspaceIcon from '@mui/icons-material/KeyboardBackspace';

const MobileFooter = ({children}) => {
    
    return (
        <Div sx={{
            padding: '12px 24px 40px',
            width: '100%',
            backgroundColor: '#FFFFFF',
            position: 'sticky',
            bottom: 0
        }}>
            {children}
        </Div>
    );
};

export default MobileFooter;